<template>
  <div
    @dragleave.prevent
    @dragover.prevent
    @drop.prevent
  >
    <Breadcrumbs
      :paths="[$route.path]"
    ></Breadcrumbs>
    <v-stepper v-model="step" vertical>
      <v-stepper-step :complete="step > 1" step="1" class="pb-0">
        {{ $t("message.similarity.specify_parameter") }}
      </v-stepper-step>
      <v-stepper-content step="1">
        <SimilarityParameter
          ref="similarity_parameter"
          :visible_panel="['source', 'title', 'model']"
          v-on:update_similaritable="similaritable = $event"
          v-on:done_upload="done_upload"
          :mode="mode"
        >
        </SimilarityParameter>

        <v-card flat class="pt-5">
          <p class="text-right">
            <v-btn
              color="primary"
              :disabled="!similaritable || executing"
              @click="execute_first()"
            >
              {{ $t("message.common.execute") }}
            </v-btn>
            <v-btn to="/">
              {{ $t("message.common.return_home") }}
            </v-btn>
          </p>
        </v-card>
      </v-stepper-content>

      <v-stepper-step step="2" class="pt-4">
        {{ $t("message.common.start_job", { job: $t("message.similarity.start_similarity") } ) }}
      </v-stepper-step>
      <v-stepper-content step="2">
        <Complete
          v-if="uploaded"
          :command_type="command_type"
          :jobs="jobs"
          :mode="mode"
          :takes_time="false">
          <template v-slot:title>
            <v-toolbar>
              <v-toolbar-title>
                {{ $t('message.complete.table_title') }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
        </Complete>
        <Failed
          v-if="!uploaded"
          :command_type="command_type"
          :uploading_files="uploading_files" />
      </v-stepper-content>
    </v-stepper>
  </div>
</template>

<script>
import Breadcrumbs from '../components/Breadcrumbs';
import SimilarityParameter from '../components/SimilarityParameter';
import Complete from '../components/Complete';
import Failed from '../components/Failed';
import { http_error } from "../js/http_error";

export default {
  name: 'similarity',
  components: {
    Breadcrumbs,
    SimilarityParameter,
    Complete,
    Failed
  },
  mixins: [http_error],
  data: function(){
    return {
      module_id: "13",
      similaritable: false,
      command_type: "similarity",
      mode:"user",
      // common
      step: 1,
      executing: false,

      // step2
      jobs: [],
      uploading_files: [],
      uploaded: true,
    }
  },
  methods: {
    execute_first: function(){
      if(this.$refs.similarity_parameter == null){
        return;
      }
      this.executing = true;
      var similarity_parameter = this.$refs.similarity_parameter;
      similarity_parameter.sources = [];
      if(similarity_parameter.source_tab === 'new_file'){
        similarity_parameter.$refs.upload.upload();
      }else{
        // "uploaded_file"
        for(var file of similarity_parameter.uploaded_files){
          similarity_parameter.sources.push({
            fid: file.fid,
            name: file.name
          });
        }
        this.execute_second();
      }
    },
    execute_second: function(){
      if(this.$refs.similarity_parameter == null){
        return;
      }
      var similarity_parameter = this.$refs.similarity_parameter;
      if(this.$store.getters.debug){
        console.log(similarity_parameter.sources);
      }
      this.jobs = [];
      var targets = [];
      if(similarity_parameter.target_tab === "model"){
        for(var model of similarity_parameter.selected_model){
          targets.push(model.mid);
        }
      }else{
        for(var corpus of similarity_parameter.selected_corpus){
          targets.push(corpus.cid);
        }
      }
      for(var source of similarity_parameter.sources){
        for(var xid of targets){
          var job = {
            "source": source.fid,
            "status": "uploading",
            "jid": null,
          };
          var take_over = {
            "job": job,
            "parent": this
          };
          var parameters = Object.assign({}, similarity_parameter.parameters);
          parameters.source = source.fid;
          parameters.target_type = similarity_parameter.target_tab;
          parameters.target = [xid];
          if(similarity_parameter.parameters.title){
            parameters.title = similarity_parameter.parameters.title
                             + ":" + source.name.replace(/\([A-Z]\d{5,8}\)/g, "") + "(" + source.fid + "): " + xid;
          }else{
            parameters.title = source.name.replace(/\([A-Z]\d{5,8}\)/g, "") + "(" + source.fid + "): " + xid;
          }
          parameters.title = parameters.title.substr(0, 80);
          job.name = parameters.title;
          this.$http.post(this.$store.getters.api_endpoint + "/action/similarity",
                          parameters,
                          {
                            headers: {
                              'Content-Type': 'application/json'
                            },
                          })
            .then(function(response){
              this.status = 'complete';
              this.jid = response.data.jid;
            }.bind(job) )
            .catch(function(error){
              this.job.status = "error";
              if(this.parent.http_error(error)){
                this.parent.$store.commit("setNotification", {
                  type: "error",
                  message: error.response.data
                });
              }
            }.bind(take_over) );
          this.jobs.push(job);
        }
      }
    },
    done_upload: function(success){
      if(this.$refs.similarity_parameter == null){
        return;
      }
      var similarity_parameter = this.$refs.similarity_parameter;
      if(this.$store.getters.debug){
        console.log(similarity_parameter.sources);
      }
      for(var file of similarity_parameter.$refs.upload.uploading_files){
        if(this.$store.getters.debug){
          console.log(file);
        }
        similarity_parameter.sources.push({
          fid: file.fid,
          name: file.file_name,
        });
        file.file_type = 'source';
      }
      this.uploaded = success;
      if(!success){
        this.uploading_files = similarity_parameter.$refs.upload.uploading_files;
        this.step = 2;
        return;
      }
      this.execute_second();
    }
  },
  watch: {
    jobs: {
      handler: function (val, oldVal) {
        var is_complete = true;
        for(var job of val){
          if(!job.jid){
            is_complete = false;
            break;
          }
        }
        if(is_complete){
          this.step = 2;
        }
      },
      deep: true
    }
  }
}
</script>
